import { MapTo } from '@adobe/aem-react-editable-components';
import PreferencesContainer from 'components/ProfileContainer/PreferencesContainer';
import React, {Component, useEffect} from 'react';

const PreferenceContainerEditConfig = {
    emptyLabel: 'Preference Container',

    isEmpty: function(props) {
        return !props;
    },
};

const PreferenceContainerWrapper = () => {

    return (
        <PreferencesContainer />
    )

}

export default MapTo('workplace-profile/components/preferencecontainer')(
    PreferenceContainerWrapper,
    PreferenceContainerEditConfig,
);
